import React, { Fragment, useState, useEffect } from 'react';
import Head from '../../../layout/Head/Head';
import axios from "axios";

import Testimonials from "../../../components/Testimonials/Testimonials";
import testimonialDecorative from '../../../assets/elements/elements_decorative_testimonial.png';
import techSnapshotDecorativeImage from '../../../assets/elements/elements_decorative_section4.png';

import ContactFormSection from "../../../components/ContactFormSection/ContactFormSection";
import TwoColumnsTextSection from "../../../hoc/TwoColumnsTextSection/TwoColumnsTextSection";

import section1Image from '../../../assets/elements/elements_section1.png';
import section3Image from '../../../assets/elements/elements_section3.png';
import formDecoration from '../../../assets/contact/contact-form-decoration-purple.png';

import { TechSnapshot } from "./components/TechSnapshot/TechSnapshot";
import Experiences from "./components/Experiences/Experiences";
import ElementsHeader from './components/ElementsHeader.js/ElementsHeader';
import Carousel from '../../../hoc/Carousel/Carousel';

import styles from './index.module.scss';

const ElementsPage = props => {
  const sectionOptions = {
    imageBackgroundMargin: "8% 0% 8% -4%",
    backgroundColor: "#FFFFFF",
    direction: 'row'
  }
  const [elementsCarousel, setElementsCarousel] = useState([]);
  const [elementsQuote, setElementsQuote] = useState([]);

  useEffect(() => {
      axios.get(`${process.env.REACT_APP_API_URL}/api/collections/get/ElementsPageFeaturedItemsCarousel`)
      .then(response => {
        setElementsCarousel(response.data.entries ? response.data.entries : [])
      })
  }, []);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/singletons/get/QuoteElements`)
    .then(response => {
      setElementsQuote(response.data ? response.data : [])
    })
  }, []);
  return (
    <Fragment>
      <Head title="Connatix - Elements" />

      <ElementsHeader {...props}/>

      <main>
        {/* Section 1 */}
        <section>
          <TwoColumnsTextSection
            image={section1Image}
            imageMargin="2% 0 0"              
            imageBackgroundMargin="-2% -4% -4%"
            direction="row-reverse"
            backgroundColor="#EFF3F5"
            title="FIND YOUR BALANCE"
            hasPaddingBottom={true}
            descriptionDecorationColor="#FFCC00"
            description="Meet Elements - the no hassle, no fee, leading OVP."
            info="Elements is an online video platform built for today's publishers.
                  Behind the scenes, algorithms are hard at work making smart decisions 
                  to drive the most revenue while delivering a flawless video experience on every screen."
          />
         </section>

        {/* Section 2 */}     
        <section>
          <Experiences />
        </section>
        
        {/* Section 3 */}
        <section>
          <TwoColumnsTextSection
            image={section3Image}
            imageMargin="4% 0"            
            imageBackgroundMargin="-8% -4%"
            direction="row-reverse"
            backgroundColor="#EFF3F5"
            hasPaddingBottom={true}
            descriptionDecorationColor="#FFCC00"
            description="Drive more revenue without the heavy lifting (and upfront costs)."
            info="With an integrated Ad Server and Exchange that were built for video, 
                  it's easy to maximize your video revenue on any channel. 
                  Oh, and did we mention there are zero storage or hosting fees?"
            buttonText="LEARN MORE"
            buttonLink="/adserver"
          />
        </section>        

        {/* Section 4 - Carousel */}
        <Carousel carouselItems={elementsCarousel} sectionOptions={sectionOptions}></Carousel>

        {/* Section 5 */}
        <section className={styles['techSnapshot-section']}>
          <img className={styles['techSnapshot-decorative']} src={techSnapshotDecorativeImage} alt=""/>
          <TechSnapshot />
        </section>

        {/* Section 6 - Testimonial */}
        <Testimonials
          company={elementsQuote.role}
          quote={elementsQuote.quote}
          name={elementsQuote.name}
          authorImg={elementsQuote.image ? `${process.env.REACT_APP_API_URL}${elementsQuote.image.path}` : ''}         
          decorativeImg={testimonialDecorative}
        />

        {/* Contact form */}
        <ContactFormSection id="elements-contact"
          title="Are you ready to light up your online video strategy?"
          titleDecorationColor='#F2DC4F'
          description="Reach out for a personalized demo."
          formID="1067"          
          formDecoration={formDecoration} 
        />
      </main>
    </Fragment>
  )
};

export default ElementsPage;